var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteiconmain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5371 10.0508L11.5487 16.0403C11.1517 16.4372 10.6133 16.6602 10.0519 16.6602C9.49051 16.6602 8.9521 16.4372 8.55508 16.0403L2.56668 10.0519C2.07166 9.5612 1.67843 8.97755 1.40958 8.33446C1.14072 7.69137 1.00154 7.00152 1.00001 6.30449C0.998486 5.60747 1.13465 4.91701 1.40068 4.27275C1.66672 3.62849 2.05739 3.04313 2.55026 2.55026C3.04313 2.05739 3.62849 1.66672 4.27275 1.40068C4.91701 1.13465 5.60747 0.998486 6.30449 1.00001C7.00152 1.00154 7.69137 1.14072 8.33446 1.40958C8.97755 1.67843 9.5612 2.07166 10.0519 2.56668C11.0486 1.59477 12.3881 1.05467 13.7803 1.0634C15.1724 1.07212 16.505 1.62896 17.4895 2.61328C18.4739 3.59761 19.031 4.93017 19.0399 6.32229C19.0488 7.71441 18.5089 9.05399 17.5371 10.0508Z",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteiconmain);
export default __webpack_public_path__ + "static/media/favoriteiconmain.0681ddb7bb70fe4d62c1e0137028a56a.svg";
export { ForwardRef as ReactComponent };